import { CREATEPHARMACYBADSTOCK, DELETEPHARMACYBADSTOCK, GETPHARMACYBADSTOCK, UPDATEPHARMACYBADSTOCK } from "src/actions/types"

const initialState = {
}

    
    // eslint-disable-next-line import/no-anonymous-default-export
    export default function (state = initialState, action) {
    
        switch (action.type) {
            case CREATEPHARMACYBADSTOCK:
                return {
                    ...state,
                    pharmacybadstockSaveStatus: action.payload.success,
                }
            case GETPHARMACYBADSTOCK:
                    return {
                            ...state,
                            pharmacybadstockList: action.payload.data,
                            }
            case UPDATEPHARMACYBADSTOCK:
                    return {
                            ...state,
                            pharmacybadstockUpdateStatus: action.payload.success,
                            }   
    
            case DELETEPHARMACYBADSTOCK:
                     return {
                         ...state,
                         pharmacybadstockDeleteStatus: action.payload.success,
                            } 
                            default:
                                return state
                                 }
                             }